export const educationData = [
  {
    place: "Develeap",
    title: "DevOps Training Program",
    years: "2025",
    technologies: ["AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "GitHub Actions", "Bash"],
  },
  {
    place: "Yezreel Valley College",
    title: "B.Sc. in Information Systems (GPA: 94.1)",
    years: "2020–2023",
    technologies: ["Operating Systems", "Databases", "Networking", "Cloud Computing"],
  },
];
